import { i18n } from "../utils/i18n";
import { getUserInfo } from "@/api/login";

let app_oauth2 = process.env.VUE_APP_OAUTH2

let app_account_client_id = process.env.VUE_APP_ACCOUNT_CLIENT_ID

if (window.location.host.slice(0,5) === 'test-') {
    app_oauth2 = app_oauth2.replace(/https?:\/\//, 'https://test-')
    app_account_client_id = 'yv86qGa054Prc9WXdZz0WAbmsRe0jaTRzA9iSYpu'
}

let app_redirect_url = process.env.VUE_APP_REDIRECT_URL

if (app_redirect_url[0] === '/') {
    app_redirect_url = window.location.origin + app_redirect_url
}

const state = {
  userInfo: {},
  nav: [
    {
      name: i18n.t("官網首頁"),
      path: "/",
      child: [
        {
          name: i18n.t("官網首頁"),
          path: "/",
        },
      ],
    },
    {
      name: i18n.t("最新消息"),
      path: "/message",
      child: [
        {
          name: i18n.t("公告"),
          path: "/message",
          type: "1",
        },
        {
          name: i18n.t("活動"),
          path: "/message",
          type: "2",
        },
        {
          name: i18n.t("更新"),
          path: "/message",
          type: "3",
        },
      ],
    },
    {
      name: i18n.t("遊戲資訊"),
      path: "/information",
      child: [
        {
          name: i18n.t("遊戲视频"),
          path: "/information",
          type: "1",
        },
        {
          name: i18n.t("遊戲地圖"),
          path: "/information",
          type: "2",
        },
        {
          name: i18n.t("遊戲指南"),
          path: "/information",
          type: "3",
        },
      ],
    },
    {
      name: i18n.t("社群"),
      path: "/community",
      child: [
        {
          name: i18n.t("玩家討論區"),
          path: "/community",
          type: "1",
        },
        {
          name: i18n.t("攻略討論區"),
          path: "/community",
          type: "2",
        },
        {
          name: i18n.t("圖片分享區"),
          path: "/community",
          type: "3",
        },
      ],
    },
    {
      name: i18n.t("客服中心"),
      path: "/serve",
      child: [
        {
          name: "FAQ",
          path: "/serve",
          type: "0",
        },
        {
          name: i18n.t("1:1詢問"),
          path: "/serve",
          type: "1",
        },
        // {
        //   name: i18n.t("回報記錄"),
        //   path: "",
        // },
        // {
        //   name: i18n.t("會員條款"),
        //   path: "/serve",
        //   type: "2",
        // },
      ],
    },
    {
      name: i18n.t("下載專區"),
      path: "/download",
      child: [
        {
          name: i18n.t("游戲下載"),
          path: "/download",
        },
      ],
    },
    {
      name: i18n.t("商城"),
      path: "/mall",
      child: [
        {
          name: i18n.t("儲值點數"),
          path: "/mall",
          type: "1",
        },
        {
          name: i18n.t("購買元寶"),
          path: "/mall",
          type: "2",
        },
        {
          name: i18n.t("購買記錄"),
          path: "/mall",
          type: "3",
        },
      ],
    },
  ],
  currentTpye: "",
  isFixed: true,
  app_oauth2: app_oauth2,
  app_redirect_url: app_redirect_url,
  app_account_client_id: app_account_client_id,
};
const mutations = {
  SET_FIXED(state, bool) {
    state.isFixed = bool;
  },
  SET_CURRENTTYPE(state, data) {
    state.currentTpye = data;
  },
  SET_USERINFO(state, data) {
    state.userInfo = data;
  },
};
const actions = {
  setFixed({ commit }, data) {
    commit("SET_FIXED", data);
  },
  async getUser({ commit }) {
    try {
      const res = await getUserInfo();
      commit("SET_USERINFO", res.data);
    } catch (e) {
      if (e.response.status === 404) {
        location.href =
        app_oauth2 +
          `/#/login?client_id=${app_account_client_id}&return_url=${app_redirect_url}`;
      }
    }
  },
};
export default {
  state,
  mutations,
  actions,
};
